import { Field, Input, Select } from '@dayon/design-system';
import type { CatalogueChangeReason } from '@dayon/contracts';
import { CATALOGUE_REASONS, NOTE_MAX, noteError } from './catalogue-write.ts';

/**
 * THE REASON AND THE NOTE — the pair all four catalogue writes ask for.
 *
 * One component rather than the same twenty lines in four dialogs, for the
 * reason `reason-note.ts` holds the bounds once: the hint text is a promise
 * about what the log will read like, and four copies of a promise drift.
 *
 * It owns no state. Each dialog holds its own, because each starts clean on
 * every opening — a reason typed for one title must never be waiting in the box
 * for the next one.
 */
export function ReasonFields({
  reasonCode,
  onReasonCode,
  note,
  onNote,
  noteTouched,
  onNoteBlur,
  placeholder,
}: {
  reasonCode: CatalogueChangeReason;
  onReasonCode: (code: CatalogueChangeReason) => void;
  note: string;
  onNote: (note: string) => void;
  noteTouched: boolean;
  onNoteBlur: () => void;
  /** What a good note looks like FOR THIS WRITE. A generic example teaches nothing. */
  placeholder: string;
}) {
  return (
    <>
      <Field
        label="Reason"
        hint="A closed set, because the Configuration log is a report as well as a story."
      >
        {({ id, describedBy }) => (
          <Select
            id={id}
            aria-describedby={describedBy}
            value={reasonCode}
            onChange={(e) => onReasonCode(e.target.value as CatalogueChangeReason)}
          >
            {CATALOGUE_REASONS.map((r) => (
              <option key={r.code} value={r.code}>
                {r.label}
              </option>
            ))}
          </Select>
        )}
      </Field>

      <Field
        label="Note"
        error={noteError(note, noteTouched)}
        hint="At least 10 characters. The code says what kind of thing happened; the note says what actually did."
      >
        {({ id, describedBy, invalid }) => (
          <Input
            id={id}
            aria-describedby={describedBy}
            aria-invalid={invalid || undefined}
            value={note}
            maxLength={NOTE_MAX}
            onChange={(e) => onNote(e.target.value)}
            onBlur={onNoteBlur}
            placeholder={placeholder}
          />
        )}
      </Field>
    </>
  );
}
